/* src/app/pages/auth/password/first-time/component.scss */
.error {
  font-size: 12px;
}
/*# sourceMappingURL=component.css.map */
